import { Box, Spacer,Wrap, WrapItem,Text } from '@chakra-ui/react'
import {  Icon } from '@chakra-ui/icons'
import {MdNotifications, MdSettings} from 'react-icons/md';
import GruntComponents from './components';
import OperAvatarInfo from './operater/OperAvatarInfo';
import { loggedOper } from '../util/grunt';




const Header = ({operater,componentSelectHandler, onLogOut}) => {
    return (
            
        
        <Box  p={'6px'} alignItems={'center'} display={'flex'} flexDir={'row'} borderTopRightRadius={'md'}  bg={'grunt2.800'}  h={'100%'}>
        <Spacer/>
            <Text as={'b'} color={'white'}>{loggedOper.klijent}</Text>
        <Spacer/>
        
        <Wrap spacing={'10px'} align='center'>
        
            <WrapItem>
                {/* <SettingsIcon color='teeal.800' onClick={()=>{componentSelectHandler(GruntComponents.Postavke)}} cursor='pointer'/> */}
                <Icon as={MdSettings} color='grunt2.100' onClick={()=>{componentSelectHandler(GruntComponents.Postavke)}} cursor='pointer'/>
            </WrapItem>
            <WrapItem>
                <Icon as={MdNotifications} color='grunt2.100' cursor='pointer'/>
            </WrapItem>
            <WrapItem>   
                <OperAvatarInfo onLogOut={onLogOut}/>
            </WrapItem>
        
        </Wrap>

           
        </Box>
    );
}

export default Header;
